import React from 'react';
import Downloads from './Downloads';

const Edit = (props) => {
  return <Downloads showDisclaimer={false} showShareButton={false} />;
};

export default Edit;
